import { Document, Page, Text, View, Canvas, Image, StyleSheet,PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { QRCode } from 'react-qrcode-logo';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4',
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
});

// Create Document Component
const MyDocument = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <Canvas>
        <QRCode
                bodyClass="mx-auto"
                id="QRCode"
                size={555}
                logoImage="/assets/images/favicon.jpg"
                imageSettings={{
                    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSshrGc3H1tmJPwlIDts0DaK67hMU45v6NH6y_5txdY&s",
                    excavate: true,
                }}
                level={"L"}
                renderAs={"svg"}
                value={`https://ipg.sabinarya.com/payment/ipg/qr/app/?terminalNumber=1233455&callback=https://petro.sabinarya.com`}
            />
        </Canvas>
      </View>
    </Page>
  </Document>
);

const Pdf = () => {
  return (
    <PDFViewer style={{width: '100%',height: '100vh'}}>
        <MyDocument />
    </PDFViewer>
    // <PDFDownloadLink document={<MyDocument />} fileName='test.pdf'>
    //     {({ blob, url, loading, error }) =>
    //     loading ? 'Loading document...' : 'Download now!'
    //   }
    // </PDFDownloadLink>
  )
}

export default Pdf